import { render } from "./ProcessPickup.vue?vue&type=template&id=9710619c&scoped=true"
import script from "./ProcessPickup.vue?vue&type=script&lang=js"
export * from "./ProcessPickup.vue?vue&type=script&lang=js"

import "./ProcessPickup.vue?vue&type=style&index=0&id=9710619c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9710619c"]])

export default __exports__